import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const COMMUNITY_POSTS = [{
  id: 1,
  user: '@iron_mike',
  img: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=1000&auto=format&fit=crop',
  height: 'h-64'
}, {
  id: 2,
  user: '@sarah_mma',
  img: 'https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?q=80&w=1000&auto=format&fit=crop',
  height: 'h-96'
}, {
  id: 3,
  user: '@cage_warrior',
  img: 'https://images.unsplash.com/photo-1544367563-12123d8965cd?q=80&w=1000&auto=format&fit=crop',
  height: 'h-72'
}, {
  id: 4,
  user: '@fight_club_official',
  img: 'https://images.unsplash.com/photo-1595078475328-1ab05d0a6a0e?q=80&w=1000&auto=format&fit=crop',
  height: 'h-80'
}, {
  id: 5,
  user: '@knockout_king',
  img: 'https://images.unsplash.com/photo-1574680096145-d05b474e2155?q=80&w=1000&auto=format&fit=crop',
  height: 'h-64'
}, {
  id: 6,
  user: '@bjj_lifestyle',
  img: 'https://images.unsplash.com/photo-1591117207239-78898dd1e847?q=80&w=1000&auto=format&fit=crop',
  height: 'h-72'
}];
export function CommunitySection() {
  return <section className="py-24 bg-fight-black relative" data-id="element-38">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 50%, rgba(245,230,20,0.015) 0%, transparent 60%)'
    }} data-id="element-39" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10" data-id="element-40">
        <div className="text-center mb-16" data-id="element-41">
          <h2 className="text-5xl md:text-7xl font-bebas mb-4" style={{
          color: '#e0e0e0'
        }} data-id="element-42">
            THE IRON CAGE <span className="yellow-glow-text" data-id="element-43">COMMUNITY</span>
          </h2>
          <p className="font-barlow text-xl tracking-widest uppercase mb-8" style={{
          color: '#555'
        }} data-id="element-44">
            Tag #IRONCAGE to be featured
          </p>
          <a href="#" className="inline-flex items-center gap-2 px-6 py-2 rounded-full font-bebas tracking-wide transition-all duration-300" style={{
          background: 'rgba(255,255,255,0.03)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255,255,255,0.08)',
          color: '#888'
        }} onMouseEnter={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(255,255,255,0.07)';
          (e.currentTarget as HTMLAnchorElement).style.color = '#e0e0e0';
        }} onMouseLeave={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(255,255,255,0.03)';
          (e.currentTarget as HTMLAnchorElement).style.color = '#888';
        }} data-id="element-45">
            <Instagram className="w-5 h-5" data-id="element-46" />
            FOLLOW US @IRONCAGE
          </a>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5" data-id="element-47">
          {COMMUNITY_POSTS.map((post, idx) => <motion.div key={post.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.08
        }} viewport={{
          once: true
        }} className={`relative group overflow-hidden break-inside-avoid ${post.height}`} style={{
          background: 'rgba(255,255,255,0.02)',
          backdropFilter: 'blur(4px)',
          border: '1px solid rgba(255,255,255,0.06)'
        }} data-id="element-48">
              <img src={post.img} alt={`Post by ${post.user}`} className="w-full h-full object-cover opacity-60 transition-all duration-700 group-hover:opacity-80 group-hover:scale-105" data-id="element-49" />
              {/* Glass overlay on hover */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex flex-col items-center justify-center" style={{
            background: 'rgba(0,0,0,0.5)',
            backdropFilter: 'blur(2px)'
          }} data-id="element-50">
                <p className="font-bebas text-xl mb-4" style={{
              color: '#e0e0e0'
            }} data-id="element-51">
                  {post.user}
                </p>
                <button className="px-6 py-2 font-bebas tracking-wider transform translate-y-3 group-hover:translate-y-0 transition-transform duration-300" style={{
              background: 'rgba(153,27,27,0.8)',
              backdropFilter: 'blur(8px)',
              border: '1px solid rgba(153,27,27,0.4)',
              color: '#e0e0e0'
            }} data-id="element-52">
                  SHOP THIS LOOK
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}